import { Injectable } from '@angular/core';
import { AccountAttributeService } from './account-attribute.service';
import { AccountAttributeClassService } from './account-attributeClass.service';
import { DatasourceMappingService } from './datasource-mapping.service';
import { DatasourceService } from './datasource.service';
import { RecurrenceService } from './recurrence.service';
import { SeriesService } from './series.service';
import { FieldService } from './field.service';
import { PeriodService } from './period.service';

@Injectable({
    providedIn: 'root'
})

export class CacheService {
    constructor(
        private attributeService: AccountAttributeService, 
        private attributeClassService: AccountAttributeClassService, 
        private datasourceMappingService: DatasourceMappingService,
        private datasourceService: DatasourceService,
        private fieldService: FieldService,
        private periodService: PeriodService,
        private recurrenceService: RecurrenceService,
        private seriesService: SeriesService,
    ) { }

    resetAllCaches() {
        this.attributeService.resetCache();
        this.attributeClassService.resetCache();
        this.datasourceMappingService.resetCache();
        this.datasourceService.resetCache();
        this.fieldService.resetCaches();
        this.periodService.resetCache();
        this.recurrenceService.resetCache();
        this.seriesService.resetCache();
    }
}
